<div class="alert my-1 shadow-sm bg-primary text-white py-1 page-title"
  [class.parte-diario-title]="titulo === 'Parte diario'" role="alert">
  {{ titulo }}
</div>
